import React from "react";
import styled from "styled-components";

const Compatibility = styled.span`
    display: block;
    font-size: 1rem;
`;

const AppCompatibility = ({starCitizenVersion}) => (
    <Compatibility title={`This app has been tested for compatibility with Star Citizen v${starCitizenVersion.version}`}>
        Star Citizen: v{starCitizenVersion.version}
    </Compatibility>
);

export default AppCompatibility;